module.exports = __webpack_public_path__ + "img/BlackVintageCar300x300.ef944380.jpg";